export enum AutomationRoutes {
  Root = "",
  AutomationManager = "automationmanager",
  Views = "view/",
  ViewStockMarket = 'view/stockmaket',
  Workflows = "workflows",
  WorkflowsTransactionSettings = "workflow/transaction-settings"
}
